import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../components/Hero';
import { Link } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export type POCElectronicsProps = {};

const POCElectronics: React.FC<POCElectronicsProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero 
        bgImage={'/img/process-checkmark.png'} 
        heading={
          intl.formatMessage({
            id: 'proc-cert'
          })
        }
        subHeading={
          intl.formatMessage({
            id: 'electronics'
          })
        }
      />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-6 !pt-8">
        <h2 className="text-2xl text-secondary font-bold uppercase">{
          intl.formatMessage({
            id: 'proc-cert'
          })
        }</h2>
        <div className="flex flex-col gap-4 mt-4 mb-8">
          <p>
            {
              intl.formatMessage({
                id: 'at_mcb',
              })
            }
          </p>
        </div>
        <div className="w-full flex flex-col md:flex-row items-center justify-between mb-12 gap-4">
          <Link to="/certification-services/process-of-certification/electronics" className="w-full sm:w-auto bg-secondary text-white py-1 px-4 font-bold uppercase">
            {
              intl.formatMessage({
                id: 'electronics'
              })
            }
          </Link>
          <Link to="/certification-services/process-of-certification/telecom" className="w-full sm:w-auto bg-secondary text-white py-1 px-4 font-bold uppercase">
            {
              intl.formatMessage({
                id: 'telecommunications'
              })
            }
          </Link>
        </div>
        <div className="w-full mb-10 max-w-[100vw] overflow-x-auto">
          {/* {lang === SiteLangs.EN && (
            <img src="/icons/poc-elect_en.svg" alt="Electronics Certification Process" />
          )}
          {lang === SiteLangs.ES && (
            <img src="/icons/poc-elect_es.svg" alt="Electronics Certification Process" />
          )}
          {lang === SiteLangs.ZH && (
            <img src="/icons/poc-elect_zh.svg" alt="Electronics Certification Process" />
          )}
          {lang === SiteLangs.PT && (
            <img src="/icons/poc-elect_pt.svg" alt="Electronics Certification Process" />
          )} */}
          <Document renderMode='canvas' onError={(e) => {console.log("!!!!", e)}} file={'/pdf/MCB-DOS-101 Diagrama del proceso de certificacio un electrotecnia.pdf'}>
            <Page width={1024} className={'flex justify-center'} renderAnnotationLayer={false} renderTextLayer={false} pageIndex={0} />
            <Page width={1024} className={'flex justify-center'} renderAnnotationLayer={false} renderTextLayer={false} pageIndex={1} />
            <Page width={1024} className={'flex justify-center'} renderAnnotationLayer={false} renderTextLayer={false} pageIndex={2} />
            <Page width={1024} className={'flex justify-center'} renderAnnotationLayer={false} renderTextLayer={false} pageIndex={3} />
            <Page width={1024} className={'flex justify-center'} renderAnnotationLayer={false} renderTextLayer={false} pageIndex={4} />
          </Document>
        </div>
       
      </div>
    </div>
  );
}

export default POCElectronics;